const baseUrl = process.env.BASE_API
const api = {
  state: {
    baseApi: baseUrl,
  },
}

export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js